import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { DragulaModule } from 'ng2-dragula';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MomentModule } from 'ngx-moment';

import { DownloaderModule } from 'app/downloader/downloader.module';
import { FormFieldsModule } from 'app/form-fields/form-fields.module';
import { FormulaBarComponent } from 'app/form-fields/table/template/formula-bar/formula-bar.component';
import { FormulaV2WarningComponent } from 'app/form-fields/table/template/formula-v2-warning/formula-v2-warning.component';
import { SegmentModule } from 'app/segment/segment.module';
import { WINDOW, windowFactory } from 'app/shared/factory/window.factory';
import { SharedModule } from 'app/shared/shared.module';
import { UIComponentsModule } from 'app/ui-components/ui-components.module';

import { AddCompanyTemplateComponent } from './template-edit/add-company-template.component';
import { AddTeamTemplateComponent } from './template-edit/add-team-template.component';
import { AddTemplateModalComponent } from './template-edit/add-template-modal.component';
import { AddTemplateSelectionComponent } from './template-edit/add-template-selection/add-template-selection.component';
import { EditTemplateModalComponent } from './template-edit/edit-template-modal/edit-template-modal.component';
import { EditTemplateComponent } from './template-edit/edit-template.component';
import { HeaderFooterEditorComponent } from './template-edit/header-footer-editor/header-footer-editor.component';
import { HeaderFooterFieldComponent } from './template-edit/header-footer-section/header-footer-field/header-footer-field.component';
import { HeaderFooterSectionComponent } from './template-edit/header-footer-section/header-footer-section.component';
import { MobileAppTemplateEditorComponent } from './template-edit/mobile-app-template-editor/mobile-app-template-editor.component';
import { NewSettingsComponent } from './template-edit/new-settings/new-settings.component';
import { PhotosPerPageSettingsComponent } from './template-edit/photos-per-page-settings/photos-per-page-settings.component';
import { TemplateFieldGroupComponent } from './template-edit/template-field-group/template-field-group.component';
import { TemplateLimitsCounterComponent } from './template-edit/template-limits-counter/template-limits-counter.component';
import { TemplateSettingsComponent } from './template-edit/template-settings/template-settings.component';
import { TemplateSettingsService } from './template-edit/template-settings/template-settings.service';
import { TemplateViewSwitcherComponent } from './template-edit/template-view-switcher/template-view-switcher.component';
import { ThumbnailSettingsPreviewComponent } from './template-edit/thumbnail-settings/thumbnail-settings-preview/thumbnail-settings-preview.component';
import { ThumbnailSettingsComponent } from './template-edit/thumbnail-settings/thumbnail-settings.component';
import { AddAppWizardComponent } from './template-edit/wizard/add-app-wizard.component';
import { WorkflowHeaderComponent } from './template-edit/workflow-header/workflow-header.component';
import { TemplateFormAddComponent } from './template-form-edit/template-form-add.component';
import { TemplateFormEditComponent } from './template-form-edit/template-form-edit.component';
import { FormCardComponent } from './template-forms/form-card/form-card.component';
import { FormRegisterViewComponent } from './template-forms/template-forms-register/form-register-view.component';
import { RegisterViewSettingFieldComponent } from './template-forms/template-forms-register/settings/register-view-setting-field/register-view-setting-field.component';
import { RegisterViewSettingComponent } from './template-forms/template-forms-register/settings/register-view-setting.component';
import { TemplateFormsRegisterComponent } from './template-forms/template-forms-register/template-forms-register.component';
import { FormListComponent } from './template-forms/template-forms-timeline/form-list.component';
import { TemplateFormsTimelineComponent } from './template-forms/template-forms-timeline/template-forms-timeline.component';
import { AppsToolBarComponent } from './template-forms/template-forms-toolbar/apps-tool-bar.component';
import { WorkflowNotificationListDropdownComponent } from './template-forms/template-forms-workflow/notification-list/work-flow-notification-list-dropdown.component';
import { WorkflowNotificationToggleComponent } from './template-forms/template-forms-workflow/notification-toggle/work-flow-notification-toggle.component';
import { TemplateFormsWorkflowComponent } from './template-forms/template-forms-workflow/template-forms-workflow.component';
import { WorkFlowComponent } from './template-forms/template-forms-workflow/work-flow.component';
import { WorkflowColumnComponent } from './template-forms/template-forms-workflow/workflow-column/workflow-column.component';
import { TemplateFormsComponent } from './template-forms/template-forms.component';
import { TemplateRawCodeButtonComponent } from './template-raw-code-button/template-raw-code-button.component';
import { AppTagComponent } from './template-tag/app-tag.component';
import { TemplateVersionPreviewComponent } from './template-version-preview/template-version-preview.component';
import { EmbedLibraryAppsComponent } from './templates-library/forms/embed-library-apps.component';
import { TemplateSelectionListComponent } from './templates-library/template-selection-list/template-selection-list.component';
import { TemplatesLibraryModule } from './templates-library/templates-library.module';
import { OrgTemplatesListComponent } from './templates-list/org-templates-list.component';
import { TeamTemplatesListComponent } from './templates-list/team-templates-list.component';
import { AppsListCardComponent } from './templates-list/templates-grid/apps-list-card.component';
import { OrgTemplatesGridComponent } from './templates-list/templates-grid/org-templates-grid.component';
import { TeamTemplatesGridComponent } from './templates-list/templates-grid/team-templates-grid.component';
import { TemplatesListCardsComponent } from './templates-list/templates-grid/templates-list-cards/templates-list-cards.component';
import { AppsListToolBarComponent } from './templates-list/templates-list-toolbar/apps-list-tool-bar.component';
import { TemplatesListModule } from './templates-list/templates-list.module';
import { OrgTemplatesRegisterComponent } from './templates-list/templates-register/org-templates-register.component';
import { TeamTemplatesRegisterComponent } from './templates-list/templates-register/team-templates-register.component';
import { TemplatesListRegisterViewComponent } from './templates-list/templates-register/templates-list-register-view.component';
import { AppsListTagFilterComponent } from './templates-list/templates-tag-filter/apps-list-tag-filter.component';
import { FormModule } from '../form/form.module';
import { AppAttachmentComponent } from '../form-fields/attachment/template/app-attachment.component';

export function registerViewTrue() {
  return true;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    MomentModule,
    NgbModule,
    InfiniteScrollModule,
    DragulaModule,
    SharedModule,
    FormModule,
    FormFieldsModule,
    SegmentModule,
    DragDropModule,
    VirtualScrollerModule,
    DownloaderModule,
    NgbTooltipModule,
    TemplatesLibraryModule,
    TemplatesListModule,
    UIComponentsModule,
    GoogleTagManagerModule,
  ],
  declarations: [
    AddTemplateModalComponent,
    EditTemplateModalComponent,
    WorkflowHeaderComponent,
    AppAttachmentComponent,
    AddAppWizardComponent,
    AppsToolBarComponent,
    AppsListToolBarComponent,
    AppsListTagFilterComponent,
    TeamTemplatesGridComponent,
    OrgTemplatesGridComponent,
    OrgTemplatesListComponent,
    AddTemplateSelectionComponent,
    RegisterViewSettingComponent,
    EmbedLibraryAppsComponent,
    AppsListCardComponent,
    AppTagComponent,
    TemplatesListRegisterViewComponent,
    TeamTemplatesListComponent,
    TeamTemplatesRegisterComponent,
    OrgTemplatesRegisterComponent,
    TemplateFormsComponent,
    TemplateFormsWorkflowComponent,
    TemplateFormsRegisterComponent,
    TemplateFormsTimelineComponent,
    TemplateSelectionListComponent,
    FormRegisterViewComponent,
    TemplateFormEditComponent,
    AddCompanyTemplateComponent,
    FormListComponent,
    FormCardComponent,
    WorkFlowComponent,
    WorkflowColumnComponent,
    WorkflowNotificationListDropdownComponent,
    WorkflowNotificationToggleComponent,
    TemplateFormAddComponent,
    EditTemplateComponent,
    AddTeamTemplateComponent,
    ThumbnailSettingsComponent,
    ThumbnailSettingsPreviewComponent,
    TemplateVersionPreviewComponent,
    TemplatesListCardsComponent,
    RegisterViewSettingFieldComponent,
    NewSettingsComponent,
    TemplateFieldGroupComponent,
    PhotosPerPageSettingsComponent,
    MobileAppTemplateEditorComponent,
    HeaderFooterSectionComponent,
    HeaderFooterFieldComponent,
    TemplateSettingsComponent,
    HeaderFooterEditorComponent,
    TemplateViewSwitcherComponent,
    FormulaBarComponent,
    TemplateLimitsCounterComponent,
    TemplateRawCodeButtonComponent,
    FormulaV2WarningComponent,
  ],
  providers: [
    {
      provide: 'isRegister',
      useValue: registerViewTrue,
    },
    { provide: WINDOW, useFactory: windowFactory },
    TemplateSettingsService,
  ],
  exports: [AddTemplateModalComponent, AppTagComponent, AppsListToolBarComponent, FormulaBarComponent],
})
export class TemplatesModule {}
